import { render, staticRenderFns } from "./TabellaTest.vue?vue&type=template&id=baadbedc&"
import script from "./TabellaTest.vue?vue&type=script&lang=js&"
export * from "./TabellaTest.vue?vue&type=script&lang=js&"
import style0 from "./TabellaTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports